import { IInventory, Inventory } from "@/entities";
import { IInventoryRepository } from "./inventory.types";
import axios from "axios"

export class InventoryAPIRepository implements IInventoryRepository {
    async getInventory(branchCode: number): Promise<Map<number, Map<number, IInventory>>> {
        const response = await axios.get(`https://villa.kitchen/api/inventory2/${branchCode}`)
        if (response.status === 200) {
            const inventoryMap = new Map()
            const inventoryData = response.data.data
            inventoryData.forEach((item: any) => {
                const iprcode = item[0];
                const stock = item[3];
                const i = new Inventory({
                    iprcode: iprcode, stock: stock
                })
                inventoryMap.set(i.iprcode, i)
            });
            const inventoryMapMap = new Map()
            inventoryMapMap.set(branchCode, inventoryMap)
            return inventoryMapMap
        } else { throw new Error(`Failed to load inventory branch ${branchCode}`); }
    }
}